import axios from "../axios";

const PODS_URL = "/api/pods";

export function fetchPOD(id: string) {
  return axios({
    url: PODS_URL + `/${id}`,
    method: "get",
  });
}
